import { Cidade, ContatoFornecedor, ContatoTransportadora, error99, Estado, RetAPI, Transportadora, TransportadoraAttributes } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const TransportadoraService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Transportadora/attributes', 'get', { id })
        const attributes: TransportadoraAttributes = {
            estados: [],
            cidades: [],
            transportadora: {
                id: 0,
                id_cidade: 0,
                id_user_insert: 0,
                id_user_last_update: 0,
                dt_cadastro: '',
                dt_last_update: '',
                razao: '',
                nome_fantasia: '',
                endereco: '',
                bairro: '',
                numero: '',
                cep: '',
                complemento: '',
                ie_rg: '',
                observacao: '',
                tipo_pessoa: '',
                cnpj_cpf: '',
                ativo: true,
                uf: '',
                nome_cidade: '',
                name_user_insert: '',
                name_user_last_update: '',
                description: ''
            }

        }

        if (resp.data) {

            let estados: Estado[] = []
            let cidades: Cidade[] = []

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.estados) {
                    estados = resp.data.estados.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome,
                            sigla: item.sigla,
                            codIBGE: item.codIBGE,
                        }
                    })
                    attributes.estados = estados
                }

                if (resp.data.cidades) {
                    cidades = resp.data.cidades.map((item: any) => {
                        return {
                            id: item.codigo,
                            description: item.nome,
                            uf: item.uf,
                            codIBGE: item.codigo,
                        }
                    })
                    attributes.cidades = cidades
                }

                if (resp.data.transportadora) {

                    attributes.transportadora.id = resp.data.transportadora.id
                    attributes.transportadora.id_cidade = resp.data.transportadora.id_cidade
                    attributes.transportadora.id_user_insert = resp.data.transportadora.id_user_insert
                    attributes.transportadora.id_user_last_update = resp.data.transportadora.id_user_last_update
                    attributes.transportadora.dt_cadastro = resp.data.transportadora.dt_cadastro
                    attributes.transportadora.dt_last_update = resp.data.transportadora.dt_last_update
                    attributes.transportadora.razao = resp.data.transportadora.razao
                    attributes.transportadora.nome_fantasia = resp.data.transportadora.nome_fantasia
                    attributes.transportadora.endereco = resp.data.transportadora.endereco
                    attributes.transportadora.bairro = resp.data.transportadora.bairro
                    attributes.transportadora.numero = resp.data.transportadora.numero
                    attributes.transportadora.cep = resp.data.transportadora.cep
                    attributes.transportadora.complemento = resp.data.transportadora.complemento
                    attributes.transportadora.ie_rg = resp.data.transportadora.ie_rg
                    attributes.transportadora.observacao = resp.data.transportadora.observacao
                    attributes.transportadora.tipo_pessoa = resp.data.transportadora.tipo_pessoa
                    attributes.transportadora.cnpj_cpf = resp.data.transportadora.cnpj_cpf
                    attributes.transportadora.ativo = resp.data.transportadora.ativo
                    attributes.transportadora.uf = resp.data.transportadora.uf
                    attributes.transportadora.nome_cidade = resp.data.transportadora.nome_cidade
                    attributes.transportadora.name_user_insert = resp.data.transportadora.name_user_insert
                    attributes.transportadora.name_user_last_update = resp.data.transportadora.name_user_last_update
                    attributes.transportadora.description = resp.data.transportadora.razao

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (transportadora: any): Promise<RetAPI> => {
        let id = ''

        if (transportadora.id) {
            id = transportadora.id.toString()
        }

        const resp = await Api('Transportadora/save', 'post', {

            razao: transportadora.razao,
            nome_fantasia: transportadora.nome_fantasia,
            endereco: transportadora.endereco,
            bairro: transportadora.bairro,
            numero: transportadora.numero,
            cep: transportadora.cep,
            id_cidade: transportadora.id_cidade,
            complemento: transportadora.complemento,
            ie_rg: transportadora.ie_rg,
            observacao: transportadora.observacao,
            tipo_pessoa: transportadora.tipo_pessoa,
            cnpj_cpf: transportadora.cnpj_cpf,
            ativo: transportadora.ativo,
            uf: transportadora.uf,
            id,
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados da Transportadora gravados com sucesso',
                id: resp.data.transportadora.id,
                data: resp.data,
                dt_cadastro: resp.data.transportadora.dt_cadastro,
                dt_last_update: resp.data.transportadora.dt_last_update,
                name_user_insert: resp.data.transportadora.name_user_insert,
                name_user_last_update: resp.data.transportadora.name_user_last_update,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Transportadora/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('Transportadora/filter', 'get', { field, filter_type, filter, id })
        const transportadora: Transportadora[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: transportadora
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.transportadora.map((item: any) => {
                    return transportadora.push({

                        id: item.id,
                        id_cidade: item.id_cidade,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        razao: item.razao,
                        nome_fantasia: item.nome_fantasia,
                        endereco: item.endereco,
                        bairro: item.bairro,
                        numero: item.numero,
                        cep: item.cep,
                        complemento: item.complemento,
                        ie_rg: item.ie_rg,
                        observacao: item.observacao,
                        tipo_pessoa: item.tipo_pessoa,
                        nome_cidade: item.nome_cidade,
                        cnpj_cpf: item.cnpj_cpf,
                        ativo: item.ativo,
                        uf: item.uf,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        description: item.razao

                    })
                })

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: transportadora
            }

        }

        return {
            error: false,
            data: transportadora,
        }

    },

    CreateContact: async (contato: ContatoTransportadora): Promise<RetAPI> => {

        const resp = await Api('Transportadora/Contato/Save', 'post', {
            id: contato.id, nome: contato.nome, telefone: contato.telefone, celular: contato.celular, setor: contato.setor, email: contato.email,
            id_transp: contato.id_transp, id_empresa: contato.empresaId
        })

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            id: resp.data.contato.id,
            msg: 'Dados gravados com sucesso'
        }


    },

    BuscarContatos: async (id_transp: number): Promise<RetAPI> => {

        const resp = await Api('Transportadora/Contato/List', 'get', { id_transp })
        let contactsList: ContatoFornecedor[] = []

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: contactsList
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || '',
                data: contactsList
            }
        }

        if (resp.data.contatos) {
            contactsList = resp.data.contatos.map((item: any) => {
                return {
                    id: item.id,
                    nome: item.nome,
                    telefone: item.telefone,
                    celular: item.celular,
                    email: item.email,
                    setor: item.setor,
                    id_transp: item.id_transp,

                    dt_cadastro: item.dt_cadastro,
                    id_user_insert: item.id_user_insert,
                    name_user_insert: item.name_user_insert,
                    dt_last_update: item.dt_last_update,
                    name_user_last_update: item.name_user_last_update
                }
            })
        }

        return {
            error: false,
            data: contactsList
        }
    },

    DeleteContato: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Transportadora/Contato/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Relatorio: async (datai: string, dataf: string, nome?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('Transportadora/Report/relatorio', 'get', { datai, dataf, nome, mostrar_excluidas })
        const transportadora: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: transportadora
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.transportadoras.map((item: any) => {
                    return transportadora.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        razao: item.razao,
                        cnpj_cpf: item.cnpj_cpf,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: transportadora
            }

        }

        return {
            error: false,
            data: transportadora,
        }

    },

    TransportadoraImportacao: async (planilha: any, mapa: any): Promise<RetAPI> => {

        const formData = new FormData()
        formData.append("mapa", JSON.stringify(mapa))
        formData.append("planilha", planilha)

        const resp = await Api('Importacao/Transportadoras', 'post', formData)

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }
    }

}
